export default "__VITE_ASSET__c777ec19__"